import { OneOrManySchema } from 'notable-common';
import { z } from 'zod';
export var HumanTaskCategoryStatus;
(function (HumanTaskCategoryStatus) {
    HumanTaskCategoryStatus["Active"] = "Active";
    HumanTaskCategoryStatus["SoftDeleted"] = "SoftDeleted";
})(HumanTaskCategoryStatus || (HumanTaskCategoryStatus = {}));
export const BaseHumanTaskCategorySchema = z.object({
    name: z.string().min(1),
    description: z.string(),
    organizationId: z.uuid(),
    state: z.enum(HumanTaskCategoryStatus),
});
export const HumanTaskCategorySchema = BaseHumanTaskCategorySchema.extend({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
});
export const HumanTaskCategoryQueryParamsSchema = z.object({
    q: z.string().optional(),
    id: OneOrManySchema(z.uuid()).optional(),
    organizationId: OneOrManySchema(z.uuid()).optional(),
    name: z.string().optional(),
    limit: z.coerce.number().positive().optional(),
    offset: z.coerce.number().min(0).optional(),
    state: z.enum(HumanTaskCategoryStatus).optional(),
});
export const BaseHumanTaskCategoryUserSchema = z.object({
    categoryId: z.uuid(),
    userId: z.uuid(),
});
export const HumanTaskCategoryUserSchema = BaseHumanTaskCategoryUserSchema.extend({
    id: z.uuid(),
    created: z.iso.datetime(),
});
export const HumanTaskCategoryUsersParamsSchema = z.object({
    categoryId: z.uuid(),
});
export const HumanTaskCategoryUserQueryParamsSchema = z.object({
    limit: z.coerce.number().positive().optional(),
    offset: z.coerce.number().min(0).optional(),
});
//# sourceMappingURL=category.js.map